module.exports = __webpack_public_path__ + "static/img/Parceiro.6714177.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Parceiro.png
// module id = FLvJ
// module chunks = 0